import axiosAuthService from '../axios';

const AdminMessagingAPIs = {
  GetThreadList: async function () {
    try {
      const response = await axiosAuthService.get(`/chat/threads/`);
      console.log('Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error getting Thread list:', error);
      throw error;
    }
  },

  CreateThread: async function (threadData) {
    try {
      const response = await axiosAuthService.post(
        `/chat/threads/`,
        threadData
      );
      console.log('Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error creating thread:', error);
      throw error;
    }
  },

  GetThreadDetail: async function (id) {
    try {
      const response = await axiosAuthService.get(`/chat/threads/${id}/`);
      console.log('Response:', response.data);
      return response.data;
    } catch (error) {
      console.error(`Error getting thread detail for ID ${id}:`, error);
      throw error;
    }
  },

  PostMessage: async function (id, messageData) {
    try {
      const response = await axiosAuthService.post(
        `/chat/threads/${id}/messages/`,
        messageData
      );
      console.log('Response:', response.data);
      return response.data;
    } catch (error) {
      console.error(`Error posting message to thread ID ${id}:`, error);
      throw error;
    }
  },

  AddParticipants: async function (id, participantsData) {
    try {
      const response = await axiosAuthService.post(
        `/chat/threads/${id}/group-management/`,
        participantsData
      );
      console.log('Response:', response.data);
      return response.data;
    } catch (error) {
      console.error(`Error adding participants to thread ID ${id}:`, error);
      throw error;
    }
  },

  RemoveParticipants: async function (id, participantsData) {
    try {
      const response = await axiosAuthService.delete(
        `/chat/threads/${id}/group-management/`,
        {
          data: participantsData,
        }
      );
      console.log('Response:', response.data);
      return response.data;
    } catch (error) {
      console.error(`Error removing participants from thread ID ${id}:`, error);
      throw error;
    }
  },

  LoadMessages: async function (id) {
    try {
      const response = await axiosAuthService.get(
        `/chat/threads/${id}/load-more/`
      );
      console.log('Response:', response.data);
      return response.data;
    } catch (error) {
      console.error(`Error loading messages for thread ID ${id}:`, error);
      throw error;
    }
  },

  SendChatRequest: async function (thread_id, requestData) {
    try {
      const response = await axiosAuthService.post(
        `/chat/threads/${thread_id}/invitations/`,
        requestData
      );
      console.log('Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error sending chat request:', error);
      throw error;
    }
  },

  GetChatRequests: async function () {
    try {
      const response = await axiosAuthService.get(`/chat/invitations/`);
      console.log('Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error getting chat requests:', error);
      throw error;
    }
  },

  AcceptDeclineChatRequest: async function (invitation_id, requestData) {
    try {
      const response = await axiosAuthService.post(
        `/chat/invitations/${invitation_id}/respond/`,
        requestData
      );
      console.log('Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error accepting/declining chat request:', error);
      throw error;
    }
  },

  SearchThreads: async function (query) {
    try {
      const response = await axiosAuthService.get(
        `/chat/threads/search_thread/`,
        {
          params: {
            q: query,
          },
        }
      );
      console.log('Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error searching threads:', error);
      throw error;
    }
  },

  // SendChatRequest: async function (requestData) {
  //     try {
  //         const response = await axiosAuthService.post(`/chat/chat_request/`, requestData);
  //         console.log('Response:', response.data);
  //         return response.data;
  //     } catch (error) {
  //         console.error('Error sending chat request:', error);
  //         throw error;
  //     }
  // },

  // GetChatRequests: async function (query) {
  //     try {
  //         const response = await axiosAuthService.get(`/chat/chat_request/`, {
  //             params: {
  //                 filter: JSON.stringify(query)
  //             }
  //         });
  //         console.log('Response:', response.data);
  //         return response.data;
  //     } catch (error) {
  //         console.error('Error getting chat requests:', error);
  //         throw error;
  //     }
  // },

  // AcceptDeclineChatRequest: async function (requestData) {
  //     try {
  //         console.log(requestData);
  //         const response = await axiosAuthService.delete(`/chat/chat_request/`, {
  //             data: requestData
  //         })
  //         console.log('Response:', response.data);
  //         return response.data;
  //     } catch (error) {
  //         console.error(`Error accepting/declining chat request for ID ${requestData.id}:`, error);
  //         throw error;
  //     }
  // }
};

export default AdminMessagingAPIs;
